import { tv } from '@change/ds-utils';

export const footer = tv({
	base: 'border-stroke-weaker bg-background-base sticky bottom-0 flex items-center justify-between border-t py-5',
});

export const footerContainer = tv({
	base: 'container flex items-center justify-between',
});

export const helpLink = tv({
	base: 'flex items-start gap-2 rounded-2xl p-0',
});

export const helpLinkText = tv({
	base: 'text-typography-strong underline',
});
